/**
 * Merkezi Yapılandırma Dosyası
 * 
 * Bu dosya tüm API ve Socket URL'lerini merkezi olarak yönetir.
 * Farklı ortamlar (development, production) için .env dosyasından değerler alır.
 * 
 * Kullanım:
 * import config from '../config';
 * fetch(`${config.API_URL}/endpoint`)
 * 
 * .env dosyasında tanımlanacak değişkenler:
 * REACT_APP_API_URL=https://api.example.com/api
 * REACT_APP_SOCKET_URL=https://api.example.com
 */

// API Base URL - Backend API endpoint'leri için
export const API_URL = process.env.REACT_APP_API_URL || 'https://apiscv.percrm.net/api';

// Socket URL - WebSocket bağlantıları için (genellikle /api olmadan)
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'https://apiscv.percrm.net';

// WebRTC/SIP Server URL (FreePBX için)
export const WEBRTC_URL = process.env.REACT_APP_WEBRTC_URL || 'wss://pbx.percrm.net:8089/ws';

// Config objesi olarak export
const config = {
  API_URL,
  SOCKET_URL,
  WEBRTC_URL,
  
  // Yardımcı metodlar
  getApiEndpoint: (path: string) => `${API_URL}${path.startsWith('/') ? path : '/' + path}`,
  getSocketUrl: () => SOCKET_URL,
  getWebRTCUrl: () => WEBRTC_URL,
};

export default config;
